(function(){

	var plugin = new springroll.ApplicationPlugin();

	plugin.setup = function()
	{
		// this is where default values would be set
		this.shuffle = plugin.shuffle.bind(this);
		this.getObjectsWithPropValue = plugin.getObjectsWithPropValue.bind(this);
		this.getRandomInt = plugin.getRandomInt.bind(this);
		this.randFromArray = plugin.randFromArray.bind(this);
		this.leftpad = plugin.leftpad.bind(this);
	};

	plugin.shuffle = function(array) 
	{
		var i = array.length, j, temp;
		if ( i === 0 ) {
			return;
		}
		while ( --i ) {
			j = Math.floor( Math.random() * ( i + 1 ) );
			temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
	};

	plugin.getObjectsWithPropValue = function (array, key, value) {
		var matches = [];
		for (var i = 0; i < array.length; i++) {
			if (array[i].hasOwnProperty(key) && array[i][key] === value) {
				matches.push(array[i]);
			}
		}
		return matches;
	};

	plugin.getRandomInt = function (min, max) {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	};

	plugin.randFromArray = function (array) {
		return array[Math.floor(Math.random() * array.length)];
	};

	plugin.leftpad = function (input, totalLength, padCharacter) {
		input = String(input);
		var i = -1;
		if (!padCharacter && padCharacter !== 0) {
			padCharacter = ' ';
		}
		totalLength = totalLength - input.length;
		while (++i < totalLength) {
			input = padCharacter + input;
		}
		return input;
	};

	plugin.teardown = function()
	{

	};

})();